import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Clock, MapPin, Users, ChevronRight } from 'lucide-react';
import { ministries } from '../mockData';

export const Ministries = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section 
        className="relative py-20 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(128, 0, 32, 0.85), rgba(128, 0, 32, 0.85)), url('https://images.unsplash.com/photo-1637285051313-5316119f852e?w=800')`
        }}
      >
        <div className="max-w-4xl mx-auto px-4 text-center text-white">
          <h1 className="text-5xl font-bold mb-4">Our Ministries</h1>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto mb-6"></div>
          <p className="text-xl text-[#fef3c7]">
            Find your place to connect, grow, and serve in our church family
          </p>
        </div>
      </section>

      {/* Ministries Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="space-y-12">
            {ministries.map((ministry, index) => (
              <Card key={ministry.id} className="overflow-hidden border-2 border-[#800020] hover:shadow-xl transition-shadow">
                <div className={`grid md:grid-cols-2 gap-0 ${index % 2 === 1 ? 'md:grid-flow-dense' : ''}`}>
                  <div className={`${index % 2 === 1 ? 'md:col-start-2' : ''}`}>
                    <img 
                      src={ministry.image} 
                      alt={ministry.name}
                      className="w-full h-full object-cover min-h-[300px]"
                    />
                  </div>
                  <CardContent className="p-8 flex flex-col justify-center">
                    <h2 className="text-3xl font-bold text-[#800020] mb-4">{ministry.name}</h2>
                    <div className="w-16 h-1 bg-[#D4AF37] mb-4"></div>
                    <p className="text-gray-700 mb-6 leading-relaxed">
                      {ministry.description}
                    </p>
                    
                    <div className="space-y-3 mb-6">
                      <div className="flex items-center gap-3 text-gray-600">
                        <Users className="h-5 w-5 text-[#D4AF37]" />
                        <span><strong>Leader:</strong> {ministry.leader}</span>
                      </div>
                      <div className="flex items-center gap-3 text-gray-600">
                        <Clock className="h-5 w-5 text-[#D4AF37]" />
                        <span><strong>Meets:</strong> {ministry.meetingTime}</span>
                      </div>
                    </div>

                    <div className="mb-6">
                      <h4 className="font-semibold text-[#800020] mb-2">Activities Include:</h4>
                      <div className="flex flex-wrap gap-2">
                        {ministry.activities.map((activity, idx) => (
                          <span 
                            key={idx}
                            className="bg-[#fffbeb] text-[#800020] px-3 py-1 rounded-full text-sm border border-[#D4AF37]"
                          >
                            {activity}
                          </span>
                        ))}
                      </div>
                    </div>

                    <Link to="/contact">
                      <Button className="bg-[#D4AF37] hover:bg-[#B8860B] text-white">
                        Get Involved
                        <ChevronRight className="h-4 w-4 ml-2" />
                      </Button>
                    </Link>
                  </CardContent>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#fffbeb]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-[#800020] mb-4">
            Ready to Get Connected?
          </h2>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto mb-6"></div>
          <p className="text-lg text-gray-700 mb-8">
            Whether you're looking to grow spiritually, serve others, or build meaningful relationships, there's a place for you at Mt. Olive. Contact us to learn more about joining a ministry.
          </p>
          <Link to="/contact">
            <Button size="lg" className="bg-[#800020] hover:bg-[#8B0000] text-white px-8 font-semibold">
              Contact Us Today
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};
